import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSendEmail } from '../hooks/useSendEmail';
import { NameInput } from 'sections/onsite-campaigns/pages/CampaignEditor/components/NameInput';

export interface SendEmailNameProps {
  id: string;
}

export const SendEmailName = ({ id }: SendEmailNameProps) => {
  const { t } = useTranslation('campaigns');

  const { setName, getName } = useSendEmail();
  const name = getName(id);

  const onChange = useCallback(
    updatedName => {
      setName(id, updatedName);
    },
    [id, setName],
  );

  return (
    <NameInput
      title={t('onsite.editor.workflow.nameInput.messageTitle')}
      name={name}
      tooltip={{
        content: t('onsite.editor.workflow.nameInput.messageTooltip'),
      }}
      onChange={onChange}
      aria-label={t('onsite.editor.workflow.sendEmailMessage.drawer.nameAria')}
    />
  );
};
